var _circle, _circle2, _rect, _rect2, _rect3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 221,
    viewBox: "0 0 224 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.934,
    cy: 94.5775,
    r: 71.7484,
    fill: "url(#paint0_linear_3328_5795)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.934,
    cy: 94.5775,
    r: 71.2484,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.4297,
    y: 70.3936,
    width: 47.9194,
    height: 47.9194,
    rx: 11.5,
    fill: "white",
    stroke: "#FFBF34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7065,
    y: 86.2341,
    width: 2.67009,
    height: 24.6906,
    rx: 1.33504,
    transform: "rotate(-42.6112 94.7065 86.2341)",
    fill: "#FFBF34",
    stroke: "#FFBF34"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110.954,
    y: 84.0239,
    width: 2.67009,
    height: 24.6906,
    rx: 1.33504,
    transform: "rotate(40.1637 110.954 84.0239)",
    fill: "#FFBF34",
    stroke: "#FFBF34"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3561,
    cy: 146.758,
    r: 9.78387,
    fill: "#FFBF34",
    fillOpacity: 0.68
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3561,
    cy: 146.758,
    r: 8.78387,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.9296,
    cy: 197.852,
    r: 5.43548,
    fill: "#FFBF34",
    fillOpacity: 0.87
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.9296,
    cy: 197.852,
    r: 4.43548,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8603,
    cy: 171.218,
    r: 2.71774,
    fill: "#FFBF34"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8603,
    cy: 171.218,
    r: 1.71774,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.29001,
    cy: 71.2046,
    r: 2.71774,
    fill: "#FFBF34"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.29001,
    cy: 71.2046,
    r: 1.71774,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.706,
    cy: 144.04,
    r: 2.71774,
    fill: "#FFBF34"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.706,
    cy: 144.04,
    r: 1.71774,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.222,
    cy: 181.002,
    r: 1.63065,
    fill: "#FFBF34"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.222,
    cy: 181.002,
    r: 1,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 1.26129
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.826,
    cy: 219.05,
    r: 1.63065,
    fill: "#FFBF34"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.826,
    cy: 219.05,
    r: 1,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 1.26129
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.65,
    cy: 1.63065,
    r: 1.63065,
    fill: "#FFBF34"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.65,
    cy: 1.63065,
    r: 1,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 1.26129
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.748,
    cy: 49.4627,
    r: 1.63065,
    fill: "#FFBF34"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.748,
    cy: 49.4627,
    r: 1,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 1.26129
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.246,
    cy: 18.4804,
    r: 5.43548,
    fill: "#FFBF34",
    fillOpacity: 0.87
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.246,
    cy: 18.4804,
    r: 4.43548,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.117,
    cy: 177.197,
    r: 5.43548,
    fill: "#FFBF34",
    fillOpacity: 0.87
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.117,
    cy: 177.197,
    r: 4.43548,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.468,
    cy: 71.7481,
    r: 11.9581,
    fill: "#FFBF34",
    fillOpacity: 0.68
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.468,
    cy: 71.7481,
    r: 10.9581,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7491,
    cy: 13.045,
    r: 11.9581,
    fill: "#FFBF34",
    fillOpacity: 0.68
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7491,
    cy: 13.045,
    r: 10.9581,
    stroke: "#FFBF34",
    strokeOpacity: 0.670588,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3328_5795",
    x1: 165.268,
    y1: 144.04,
    x2: -2.68864,
    y2: -19.5677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.440102,
    stopColor: "#FFBF34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FFBF34",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFail);
export default __webpack_public_path__ + "static/media/payment-fail.4e42e3a5f5e6a3628b53e8893020f988.svg";
export { ForwardRef as ReactComponent };